<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>持仓管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="债券代码">
				<el-input v-model="formInline.bondCode"></el-input>
			</el-form-item>
			<el-form-item label="银行">
				<el-select v-model="formInline.city" placeholder="选择银行" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in manageCityList"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>


			<el-form-item label="是否持仓">
				<el-select v-model="formInline.isHold" placeholder="选择是否持仓" clearable>
					<el-option label="持仓" value="1">
					</el-option>
					<el-option label="已出" value="0">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="买入日期">
					<el-date-picker v-model="formInline.buyDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
					</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
				<el-button size="small" type="danger" icon="el-icon-search" @click="add" v-if="jurisdiction.includes(325)">新增</el-button>
				<el-button size="small" type="primary" icon="el-icon-search" @click="updateBondHold" v-if="jurisdiction.includes(331)" >更新数据</el-button>
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" 
			:row-style='changeRowBgColor'>
			<el-table-column sortable prop="bondCode" label="债券代码" width="100" align="center"></el-table-column>
			<el-table-column prop="city" label="银行" align="center"></el-table-column>
			<el-table-column prop="buyDate" label="买入" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.buyTradingDate}}</div>
					<div>{{scope.row.buyDate}}</div>
					<div>{{scope.row.buyNetPrice}}</div>
                    <div>{{scope.row.buyFullPrice}}</div>
					<div v-if="scope.row.priceRemark">[{{ scope.row.priceRemark }}]</div>
					<div>{{scope.row.buyValue}}</div>
                </template>
			</el-table-column>
			<el-table-column prop="buyVolume" label="买入量" align="center"></el-table-column>
			<el-table-column prop="buyDate" label="卖出" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.sellTradingDate}}</div>
					<div>{{scope.row.sellDate}}</div>
					<div>{{scope.row.sellNetPrice}}</div>
                    <div>{{scope.row.sellFullPrice}}</div>
					<div>{{scope.row.sellValue}}</div>
                </template>
			</el-table-column>

			<el-table-column prop="priceDiff" label="价差" align="center"></el-table-column>
			<el-table-column prop="capitalGains" label="资本利得" align="center"></el-table-column>
			<el-table-column prop="interestIncome" label="利息收入" align="center"></el-table-column>
			<el-table-column prop="interestPayed" label="票息兑付" align="center"></el-table-column>
			<el-table-column prop="totalIncome" label="总收入" align="center"></el-table-column>
			<el-table-column prop="remark" label="备注" align="center"></el-table-column>
			<!-- <el-table-column prop="isHold" label="是否持仓" align="center"></el-table-column> -->
			<el-table-column align="center" label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleedit( scope.row)" style="margin-right: 20px;" v-if="jurisdiction.includes(325)">修改</el-button>
                    <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete"  @click="handledelete( scope.row)" v-if="jurisdiction.includes(326)">删除</el-button>
                </template>
            </el-table-column>
		</el-table>
		

		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>


		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible">
			<el-form :rules="rules" :model="editForm">
				<el-form-item label="债券代码：" label-width="140px">
				<el-input v-model="editForm.bondCode"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="银行：" label-width="140px">
					<el-select v-model="editForm.city" placeholder="选择银行" clearable  style="width:200px">
						<el-option :label="item" :value="item" v-for="(item,key) in cityList"
							:key="key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否持仓：" label-width="140px">
					<el-select v-model="editForm.isHold" placeholder="选择是否持仓" clearable  style="width:200px">
						<el-option :label="item.label" :value="item.value" v-for="(item,key) in isholdList"
							:key="key"></el-option>
					</el-select>




					<!-- <el-select clearable v-model="editForm.isHold" placeholder="选择是否持仓" style="width:200px">
						<el-option label="持仓" value="1"></el-option>
						<el-option label="已出" value="0"></el-option>
					</el-select> -->
				</el-form-item>

				<el-form-item label="买入金额（万）:" label-width="140px">
				<el-input v-model="editForm.buyVolume"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="买入交易日期：" label-width="140px">
					<el-date-picker v-model="editForm.buyTradingDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期" style="width:200px">
				</el-date-picker> 
				</el-form-item>
				<el-form-item label="结算日期：" label-width="140px">
					<el-date-picker v-model="editForm.buyDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期" style="width:200px">
				</el-date-picker> 
				</el-form-item>
				<el-form-item label="买入净价:" label-width="140px">
				<el-input v-model="editForm.buyNetPrice"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="买入全价:" label-width="140px">
				<el-input v-model="editForm.buyFullPrice"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="价格备注:" label-width="140px">
				<el-input v-model="editForm.priceRemark"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="买入收益率（%）:" label-width="140px">
				<el-input v-model="editForm.buyValue"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="卖出交易日期：" label-width="140px">
					<el-date-picker v-model="editForm.sellTradingDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期" style="width:200px">
				</el-date-picker> 
				</el-form-item>
				<el-form-item label="结算日期：" label-width="140px">
					<el-date-picker v-model="editForm.sellDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期" style="width:200px">
				</el-date-picker> 
				</el-form-item>
				<el-form-item label="卖出净价:" label-width="140px">
				<el-input v-model="editForm.sellNetPrice"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="卖出全价:" label-width="140px">
				<el-input v-model="editForm.sellFullPrice"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="卖出收益率（%）:" label-width="140px">
				<el-input v-model="editForm.sellValue"  style="width:200px"></el-input>
				</el-form-item>

				<el-form-item label="价差:" label-width="140px">
				<el-input v-model="editForm.priceDiff"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="资本利得:" label-width="140px">
				<el-input v-model="editForm.capitalGains"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="利息收入:" label-width="140px">
				<el-input v-model="editForm.interestIncome"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="票息兑付:" label-width="140px">
				<el-input v-model="editForm.interestPayed"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="备注:" label-width="140px">
				<el-input v-model="editForm.remark"  style="width:200px"></el-input>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="addEdit" >设置</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAllCity,
		getManageCity,
		addEditCityHold,
		delCityCityHold,
		getCityHold,
		updateBondHold
	} from '../../api/basisMG.js'
	// import methodsMixin from '@/utils/methodsMixin'
	// 导出模块
	export default {
		// mixins: [methodsMixin],

		// 模块数据
		data() {
			//数据  
			return {
				jurisdiction:JSON.parse(sessionStorage.getItem('jurisdiction')),
				isholdList:[{label:'持仓',value:1},{label:'已出',value:0}],
				cityList: [],
				manageCityList:[],
				analysisMap:{},
				listData: [],
				alldata: false,
				checkAll: false,
				isIndeterminate: true,
				checkedLimit: [],

				loading: false,
				Visible: false,
				time: [],
				checkboxGroup: [],
				type: 'showVip',
				fileList: [],

				dialogImageUrl: '',
				dialogVisible: false,
				// 所属分类
				tableData: [],
				value: [],
				editForm: {},
				selectEditForm: {},
				usernames: ''
			}
		},
		watch: {},
		methods: {
			towNumber(val,len) {
				return parseFloat(val).toFixed(len)    
			},
			changeRowBgColor({ row }) { 
				let styleJson = {}
				if (row.isHold === 1){
				styleJson = { "color": "red" };} 
				return styleJson
			},
			getAllCity() {
				getAllCity().then(res => {
					if (res.code == '200') {
						this.cityList = res.data
					}
				})
				getManageCity().then(res => {
					if (res.code == '200') {
						this.manageCityList = res.data
						console.log("this.cityList",this.cityList)
					}
				})
			},
						// 获得数据
			getdata() {
				let param = this.formInline
				getCityHold(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})
			},

			updateBondHold(){
				let param = this.formInline
				updateBondHold(param).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
			},

			add() {
				this.dialogVisible=true
				this.editForm={}
			},
			handleedit(row) {
				console.log(row)
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
            addEdit(){
                addEditCityHold(this.editForm).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
            },

			// 删除
			handledelete(row) {
				let msg = '确认删除?'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delCityCityHold({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.getdata()
						}
					})
				})
			},



		},
		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
			this.getAllCity()
		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
</style>